import { atom } from 'jotai'
import type { ReferralItem } from './referral.api'

export const referralLoadingAtom = atom<boolean>(false)
export const referralLoadedAtom = atom<boolean>(false)
export const referralCodeAtom = atom<string>('')
export const referralDataAtom = atom<ReferralItem | null>(null)
/** Referral code from a deep link that failed validation; ReferralBar consumes it to show the error. */
export const pendingReferralErrorAtom = atom<string>('')
